export const DEBUG = false
export const API_ENDPOINT = DEBUG? "http://localhost:8000": "https://internationalscholarsjournals.org"
export const ASSETS_ENDPOINT = "https://s3.amazonaws.com/cdn.internationalscholarsjournals.org"